import React from 'react';
import {
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    useMediaQuery
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatFirestoreTimestampMMDDYYYY } from '../../../utils/time_utils/TimeUtils';
import { StringKeys } from '../../../resources/strings/StringKeys';
import { useOrganizationContext } from '../../../context/organization_context/OrganizationContext';
import { IconCaretRightFilled } from '@tabler/icons-react';
import { useNavigate, Link } from 'react-router-dom';
import { translateReviewCycle } from '../../../utils/translations/ReviewCycleUtils';

const PerformanceReviewsTable = ({ reviews }) => {
    const { t } = useTranslation();
    const { getEmployeeByID } = useOrganizationContext()
    const isMobile = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate()

    const getStatusChipProps = (status) => {
        const statusMap = {
            'PENDING_EMPLOYEE': { color: 'warning', label: t(StringKeys.PENDING_EMPLOYEE) },
            'PENDING_MANAGER': { color: 'info', label: t(StringKeys.PENDING_MANAGER) },
            'PENDING_MEETING': { color: 'secondary', label: t(StringKeys.PENDING_MEETING) },
            'COMPLETED': { color: 'success', label: t(StringKeys.COMPLETED) }
        };
        return statusMap[status] || { color: 'default', label: status };
    };

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>{t(StringKeys.EMPLOYEE)}</TableCell>
                        {!isMobile && <TableCell sx={{ fontWeight: 'bold' }}>{t(StringKeys.REVIEW_CYCLE)}</TableCell>}
                        {!isMobile && <TableCell sx={{ fontWeight: 'bold' }}>{t(StringKeys.DUE_DATE)}</TableCell>}
                        {isMobile && <TableCell></TableCell>}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {reviews.map((review) => (
                        <TableRow
                            onClick={() => {
                                !isMobile && navigate(`/performance-reviews/${review.id}`);
                            }}
                            style={{ cursor: !isMobile ? 'pointer' : 'default' }}
                            key={review.id}
                        >
                            <TableCell>{getEmployeeByID(review.employee_id).first_name} {getEmployeeByID(review.employee_id).last_name}</TableCell>
                            {!isMobile && <TableCell>{translateReviewCycle(review.review_cycle, t)}</TableCell>}
                            {!isMobile && 
                            <TableCell>
                                {formatFirestoreTimestampMMDDYYYY(review.due_date)}
                            </TableCell>
                            }
                            {isMobile && 
                                    <TableCell sx={{textAlign:"end"}}>
                                        <IconButton
                                            component={Link}
                                            to={`/performance-reviews/${review.id}`}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <IconCaretRightFilled />
                                        </IconButton>
                                    </TableCell>
                                }
                        </TableRow>
                    ))}
                    {reviews.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={5} align="center">
                                {t(StringKeys.NO_PERFORMANCE_REVIEWS_TO_DISPLAY)}
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>

    );
};

export default PerformanceReviewsTable;
